import EditList from './EditList';

export default EditList;
